import styled from 'styled-components';
import ProductImg01 from '../../assets/index-pro-01.png';
import ProductImg02 from '../../assets/index-pro-02.png';
import ProductImg03 from '../../assets/index-pro-03.png';

const Section = styled.section`
  background: #faf5f3;
  padding: 3rem 0 2.5rem 0;
`;

const Heading = styled.h1`
  font-size: 2rem;
  font-weight: 500;
  margin-bottom: 0.5rem;
  text-align: left;
  color: #111;
  padding-left: 2.5rem;
`;

const ProductGrid = styled.div`
  display: flex;
  flex-direction: row;
  gap: 3.5rem;
  justify-content: center;
  align-items: flex-start;
  padding: 0 3rem;
  @media (max-width: 900px) {
    flex-direction: column;
    gap: 3rem;
    padding: 0 1rem;
  }
`;

const Card = styled.div`
  background: transparent;
  border-radius: 0.5rem;
  flex: 1 1 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  min-width: 300px;
  max-width: 440px;
`;

const ProductImageWrapper = styled.a`
  display: inline-flex;
  justify-content: center;
`;

const ProductImage = styled.img`
  width: 90%;
  margin: 0;
  aspect-ratio: 1/1;
  object-fit: contain;
  border-radius: 0rem;
  background: #faf5f3;
`;

const CardTitle = styled.h2`
  font-size: 1.35rem;
  font-weight: 500;
  margin: 0 0 1rem 0;
  color: #111;
  text-align: left;
`;

const CardText = styled.p`
  color: #444;
  font-size: 1rem;
  font-weight: 400;
  margin-bottom: 0.7rem;
  text-align: left;
  line-height: 1.5;
`;

const ButtonRow = styled.div`
  display: flex;
  justify-content: flex-start;
  width: 100%;
`;

const Button = styled.a<{ disabled?: boolean }>`
  background: #f87b15;
  color: #000;
  font-weight: 700;
  font-size: 1rem;
  padding: 0.7rem 2.2rem;
  border-radius: 0.5rem;
  margin-top: 0.5rem;
  box-shadow: 0 2px 8px rgba(0,0,0,0.04);
  text-align: center;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
  pointer-events: ${({ disabled }) => (disabled ? 'none' : 'auto')};
  transition: background 0.2s, color 0.2s;
  font-family: 'Nunito', sans-serif;

  &:hover {
    background: ${({ disabled }) => (disabled ? '#f87b15' : '#ff9a3c')};
    color: #000;
  }
`;

export default function ChoosingProduct() {
  return (
    <Section>
      <Heading>Choosing Sensforge just makes sense</Heading>
      <ProductGrid>
        <Card>
          <ProductImageWrapper href="/indoor-pan-tilt-camera">
            <ProductImage src={ProductImg01} alt="Product" />
          </ProductImageWrapper>
          <CardTitle>Indoor Pan-Tilt Camera</CardTitle>
          <CardText>
            The Sensforge Indoor Pan-Tilt camera gives you full control at an unbeatable price.           </CardText>
          <CardText>
            Follow the action around the room, see every detail in HD, and talk through two-way audio—all without a subscription. Smart security that’s simple, effective, and truly yours.          </CardText>
          <ButtonRow>
            <Button href="/indoor-pan-tilt-camera">Explore Features</Button>
            <Button href="https://www.amazon.com/dp/B0F22F8CZP" style={{ marginLeft: '1rem' }}>Buy Now</Button>
          </ButtonRow>
        </Card>
        <Card>
          <ProductImageWrapper href="#">
            <ProductImage src={ProductImg02} alt="Product" />
          </ProductImageWrapper>
          <CardTitle>Battery Camera</CardTitle>
          <CardText>
            No wires. No restrictions. Just pure freedom.
          </CardText>
          <CardText>
            Coming soon: a battery-powered camera designed for life on the move—from weekend hikes and city commutes to backyard adventures and remote job sites, this camera has no wires and no restrictions.
          </CardText>
          <ButtonRow>
            <Button href="#" disabled>Available Soon</Button>
          </ButtonRow>
        </Card>
        <Card>
          <ProductImageWrapper href="/smart-bird-feeder">
            <ProductImage src={ProductImg03} alt="Product" />
          </ProductImageWrapper>
          <CardTitle>Smart Bird Feeder</CardTitle>
          <CardText>
            Powered by solar energy, this camera lets you capture your garden's busiest visitors without the hassle of cables or battery changes.
          </CardText>
          <CardText>
            <p>Perfect for bird lovers who want a closer look, effortlessly.</p>
            <p> </p>
            <p> </p>
          </CardText>
          <ButtonRow>
            <Button href="/smart-bird-feeder">Explore Features</Button>
            <Button href="https://www.amazon.com/dp/B0F84HNS3V" style={{ marginLeft: '1rem' }}>Buy Now</Button>
          </ButtonRow>
        </Card>
      </ProductGrid>
    </Section>
  );
}